import React from 'react'

const Icon = ({ block }) => {
  if (!block.attrs.svg) {
    return null
  }

  const size = block.attrs.size || 64
  const hasBackground = block.attrs.hasBackground || false

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
      }}
    >
      <div
        className={hasBackground ? 'has-background-primary' : ''}
        style={{
          display: 'inline-block',
          padding: '1rem',
          borderRadius: '50%',
          marginBottom: '1rem',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={size}
          height={size}
          viewBox="0 0 172 172"
          className={`wp-block-icon${
            block.attrs.isCentered ? '--center' : ''
          } ${hasBackground ? 'has-background-primary' : ''}`}
          dangerouslySetInnerHTML={{ __html: block.attrs.svg }}
        />
      </div>
    </div>
  )
}

export default Icon
